export const getPhoneCallUrl = phone => `tel:${phone.replace(/\s/g, '')}`;

export const getMailUrl = email => `mailto:${email}`;
